<script setup>
import Text from "~/components/atoms/Text.vue";

const props = defineProps({
  title: String,
  number: Number,
  isTransparent: {
    type: Boolean,
    default: false
  },
  rightButton: Object
});
</script>

<template>
  <div class="g-16">
    <div v-if="title || props.rightButton" class="title row full-width g-16">
      <div class="circle no-flex flex-center" v-if="number">
        <Text tag="b">{{ number }}</Text>
      </div>

      <div v-if="title">
        <Text tag="strong">{{ title }}</Text>
      </div>

      <div v-if="props.rightButton" class="row left-auto flex-end right-btn uppercase clickable"
           @click="$emit('rightClick')">
        <div class="row g-8">
          <Text tag="b">{{ props.rightButton.title }}</Text>
          <div v-if="props.rightButton.icon" class="icon">
            <component :is="props.rightButton.icon"/>
          </div>
        </div>
      </div>
    </div>
    <div class="block-content" :class="{transparent:isTransparent}">
      <slot/>
    </div>
  </div>
</template>

<style scoped lang="scss">
.circle {
  min-width: 30px;
  min-height: 30px;
  max-width: 30px;
  max-height: 30px;
  background: $white;
  font-size: 16px;
}

.title {
  strong {
    font-size: 18px;

    @include smd {
      font-size: 16px;
    }
  }
}

.block-content:not(.transparent) {
  background: $white;
  padding: 30px;
  box-shadow: 0px 4px 45px 0px #F9F9F9;


  @include smd {
    padding: 16px;
  }
}

.right-btn {
  font-size: 14px;

  svg {
    stroke: $dark-black;
  }
}
</style>
